import React, { useEffect, useState } from "react";

import AppContext from "./AppContext";
import useMe from "./common/apollo/hooks/useMe";

const AppProvider = (props) => {
  const [me, setMe] = useState(null);

  const { data: meData, loading } = useMe();

  useEffect(() => {
    if (!loading) {
      setMe(meData);
    }
  }, [loading, meData]);

  return (
    <AppContext.Provider value={{ me, setMe }}>
      {props.children}
    </AppContext.Provider>
  );
};

export default AppProvider;
